import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const Changelog: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        d='M20 5.25v1.5H10v-1.5zm-10 7.5h10v-1.5H10zm0 6h10v-1.5H10zm-6 0h2v-1.5H4zm1.75-6.56V8A1.25 1.25 0 017 6.75h.89v-1.5H7A2.75 2.75 0 004.25 8v4.19l-1.72-1.72-1.06 1.06L5 15.06l3.53-3.53-1.06-1.06z'
        fill='currentColor'
      />
      <path fill='none' d='M0 0h24v24H0z' />
    </svg>
  </i>
);

Changelog.displayName = 'Changelog';
export default Changelog;
